import { connect } from 'react-redux';
import { SubmissionError, initialize } from 'redux-form';
import { browserHistory } from 'react-router';
import { getNextStep, loadProduct, submitForm, stopSubmitForm } from '../actions/users';
import Product from '../components/Product.js';

const mapStateToProps = (state) => {

    return {
        loan_amount_value: 10,
        loan_quotas_value: 20,
        isLoading: state.users.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setDefaultValue(values) {
            dispatch(initialize('product', values, null));
        },
        addProduct(values, dispatch) {
            values = { ...values, requested_amount: values.requested_amount.toString() }
            dispatch(submitForm());
            return dispatch(loadProduct(values)).then((result) => {
                if (result.payload.response && result.payload.response.status !== 200) {
                        dispatch(stopSubmitForm());
                        throw new SubmissionError(result.payload.response.data);
                }
                dispatch(getNextStep()).then((result) => {
                    if (typeof(result.payload.data.endpoint) !== 'undefined') {
                        sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                        dispatch(stopSubmitForm());
                        browserHistory.push(result.payload.data.endpoint);
                    }
                });
            });
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Product);



/** WEBPACK FOOTER **
 ** ./src/containers/ProductContainer.js
 **/